export class UserData {
    User: string;
    Authentication: string;
    IsValid: boolean;
    page: string;
    pageSize: string;
    pid: string;
    IsAdminUser: boolean;
    FromTime: string;
    ToTime: string;
    DateFrom: string;
    DepartmentID: string;
    DayCode: string;
    TestCode: string;
    ReqNo: string;
    InstructionId: string;
    flag: string;
    LocationId: string;
    RequestDate1: string;
    RequestTime: string;
    TestName: string;
    DoctorName: string;
    Status: string;   
    ErrorMessage: string;
    ImageByte: string;
    SecureValue: string;
    DefaultCPRNOLength: string;
    HospitalName: string;
    SessionTimeout: string;
    DeptName: string;
    Slot: string;
    PayAmount: string;
    IsPatientValid: boolean;
    RoleId: number;
    CPRNOlength: string;
    PortalType: string;
    ISUserLogin: string;
    constructor(user: string, authen: string, pid: string, IsAdminUser: boolean) {
        this.User = user;
        this.Authentication = authen;
        this.pid = pid; 
        this.IsAdminUser = IsAdminUser;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/usersecurity/userdata.ts